import type { RefObject } from 'react';

/**
  ApiAutoComplete -> TextInput -> DownshiftInput.

  The first child here is ApiAutoComplete. The second child is TextInput. The final child or child node
  is the wrapped Downshift component. This should not be reused elsewhere, its highly specific to this component
  path.
*/
export function getToChildDownshiftInput(ref: RefObject<HTMLInputElement>) {
  return ref?.current?.getElementsByTagName('input')[0];
}
